module.exports = __webpack_public_path__ + "static/media/IMG_1207.8a4eaea7.jpg";